const options = {
  sizePerPageList: [
    {
      text: '5',
      value: 5,
    },
  ],
  sizePerPage: 5,
  prePage: 'Prev',
  nextPage: 'Next',
};

export default options;
